<app-faq
  heading="Faq"
  subtitle="Here's the answers to your most asked questions."
  [faq]="faq"
></app-faq>
